import ClubTierUpgradeModal from "@/components/ClubTierUpgradeModal";
import {useInAppStore} from "@/InAppStoreProvider.tsx";
import {useJwtUser} from "@/JWTAuthProvider";
import Paywall from "@/user/Paywall";

interface PaywallWrapperProps {
    onClose?: () => void;
    trialHasExpired?: boolean;
    onboarding?: boolean;
}

/**
 * Smart paywall wrapper that shows the appropriate subscription modal
 * based on whether the user has a club/community or not.
 *
 * - If on Cordova (mobile): Show original Paywall (new paywall doesn't work on mobile yet)
 * - If user has a club or community: Show ClubTierUpgradeModal
 * - Otherwise: Show regular player Paywall
 */
export default function PaywallWrapper({onClose, trialHasExpired, onboarding}: PaywallWrapperProps) {
    const user = useJwtUser();
    const appStore = useInAppStore();

    if (appStore.enabled) {
        return <Paywall onClose={onClose} trialHasExpired={trialHasExpired} />;
    }

    const organizerUid = user?.club?.uid || user?.community?.uid;
    if (organizerUid) {
        return (
            <ClubTierUpgradeModal
                clubUid={organizerUid}
                isOpen={true}
                onClose={onClose || (() => {})}
                reason="feature"
                onboarding={onboarding}
            />
        );
    }

    return <Paywall onClose={onClose} trialHasExpired={trialHasExpired} />;
}
